import React, { useRef, useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import {
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    FieldWrappers,
    ModalHeader,
} from "../Styles/InputStyles";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import { MdClose, MdEdit } from "react-icons/md";
import CategoryCard from "../CategoryCard";
import SinglePropSelectModal from "../SinglePropSelectModal";
import Config, { assetAssignTo } from "../../Config";
import SelectOptionModal from "../SelectOptionModal";
import { FaPlus } from "react-icons/fa";

const AssignmentDetails = ({
    setIsAssignmentDetails,
    property,
    assignPropertyMutate,
    assignPropertyLoading,
    selectedData,
    staffList
}) => {
    const formikRef = useRef(null);
    const [height, setHeight] = useState(window.innerHeight);
    const [showPropertyModal, setShowPropertyModal] = useState(false)
    const [selectedProperty, setSelectedProperty] = useState(null);
    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
    const [isAssignStaffModalOpen, setIsAssignStaffModalOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight); // updates when Safari UI changes
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const initialValues = {
        assignedProperty: "",
        assignTo: "",
        currentStatus: "",
        count: "",
        assetId: selectedData?.id,
        assignToId: "",
    };
    // const assignToOptions = assetAssignTo.map(role => ({
    //     label: role.label,
    //     value: role.value,
    // }));
    const assignToOptions = assetAssignTo
        .filter((role) => {
            if (selectedData?.type === 10) {
                return (
                    role.value !== Config.ASSET_ASSIGNED_TO.TENANT
                );
            }
            return true;
        })
        .map((role) => ({
            label: role.label,
            value: role.value,
        }));
    const assignToStaffOptions = staffList.map(role => ({
        label: role.name,
        value: role.id,
    }));
    const filteredProperties = property?.filter(
        (prop) =>
            !(
                selectedData?.propertyAssets?.length > 0 &&
                selectedData?.propertyAssets?.some((asset) => asset.propId === prop.id)
            )
    );

    const validationSchema = Yup.object({
        assignedProperty: Yup.string().required("Select Property"),
        assignTo: Yup.string().required("Select Assign To"),
        // count: Yup.number()
        //     .required("Count is required")
        //     .min(1, "Units should not be less than 1")
        //     .max(10000, "Units should be less than 10000")
        //     .test(
        //         "is-less-than-free",
        //         `Count should not be more than ${selectedData?.free}`,
        //         function (value) {
        //             return value <= selectedData?.free;
        //         }
        //     ),
        count: Yup.number().when([], {
            is: () => selectedData?.type !== 10,
            then: (schema) =>
                schema
                    .required("Count is required")
                    .min(1, "Units should not be less than 1")
                    .max(10000, "Units should be less than 10000")
                    .test(
                        "is-less-than-free",
                        `Count should not be more than ${selectedData?.free}`,
                        function (value) {
                            return value <= selectedData?.free;
                        }
                    ),
            otherwise: (schema) => schema.notRequired(),
        }),
        assignToId: Yup.string().test(
            'assignToId-required',
            'Please select staff member',
            function (value) {
                const { assignTo } = this.parent;
                if (assignTo == Config.ASSET_ASSIGNED_TO.STAFF) {
                    return value && value.trim().length > 0;
                }
                return true;
            }
        )
    });

    const handleSubmit = (values) => {
        assignPropertyMutate({
            assetId: selectedData?.id,
            propId: values.assignedProperty,
            // count: Number(values.count),
            count: selectedData?.type === 10 ? Number(selectedData?.free) : Number(values.count),
            status: 1,
            assignedTo: Number(values.assignTo),
            assignedToId: Number(values.assignTo) === Config.ASSET_ASSIGNED_TO.STAFF
                ? Number(values.assignToId)
                : null,
        });
    };

    const handleSelectedProperty = (selectedOption) => {
        setSelectedProperty(selectedOption);
        if (formikRef.current) {
            formikRef.current.setFieldValue("assignedProperty", selectedOption.id)
        }
    }

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">{"Assignment"}</h1>
                <CloseButton onClick={() => setIsAssignmentDetails(false)}>
                    <MdClose size={24} />
                </CloseButton>
            </ModalHeader>
            <Content>
                <Formik
                    innerRef={formikRef}
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validationSchema={validationSchema}
                >
                    {({ values, setFieldValue, errors, touched }) => {
                        const getAssignLabel = () => {
                            const selectedAssignTo = assetAssignTo.find(role => role.value === values?.assignTo);
                            return selectedAssignTo ? selectedAssignTo.label : "Select Assign To";
                        };

                        const handleAssignToSelect = (selectedValue) => {
                            setFieldValue("assignTo", selectedValue);
                            setFieldValue("assignToId", "");
                        };

                        const getAssignStaffLabel = () => {
                            const selectedAssignToId = staffList.find(role => role.id === values?.assignToId);
                            return selectedAssignToId ? selectedAssignToId.name : "Select Assign To";
                        };

                        const handleAssignToStaffSelect = (selectedValue) => {
                            setFieldValue("assignToId", selectedValue);
                        };
                        const isStaffRequired = values.assignTo === Config.ASSET_ASSIGNED_TO.STAFF;
                        return (
                            <Form>
                                <ScrollableContent>
                                    <Wrapper>
                                        <InputGroup>
                                            <Label>Select Property *</Label>
                                            <CategoryCard
                                                title="Property"
                                                selectedCategory={selectedProperty}
                                                onClick={() => setShowPropertyModal(true)}
                                            />
                                            {errors.assignedProperty && touched.assignedProperty && (
                                                <ErrorText>{errors.assignedProperty}</ErrorText>
                                            )}
                                        </InputGroup>
                                        {selectedData?.type !== 10 &&
                                            <InputGroup>
                                                <Label htmlFor="count">Assign Units *</Label>
                                                <FieldWrappers>
                                                    <Field
                                                        type="text"
                                                        id="count"
                                                        name="count"
                                                        inputMode="numeric"
                                                        value={values.count}
                                                        autoComplete="off"
                                                        onKeyPress={(e) => {
                                                            if (!/[0-9]/.test(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        maxLength={10}
                                                    />
                                                </FieldWrappers>
                                                {touched.count && errors.count && (
                                                    <ErrorText>{errors.count}</ErrorText>
                                                )}
                                            </InputGroup>}
                                        <InputGroup>
                                            <Label htmlFor="assignTo">Assign To *</Label>
                                            <FieldWrappers onClick={() => setIsAssignModalOpen(true)}>
                                                <Field
                                                    type="text"
                                                    name="assignTo"
                                                    id="assignTo"
                                                    autoComplete="off"
                                                    readOnly
                                                    value={getAssignLabel()}
                                                    className="w-full border-none outline-none bg-transparent cursor-pointer"
                                                />
                                                <IconWrapper >
                                                    <FaPlus className="w-3 h-3" />
                                                </IconWrapper>
                                                {/* <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" /> */}

                                            </FieldWrappers>
                                            {errors.assignTo && touched.assignTo && (
                                                <ErrorText>{errors.assignTo}</ErrorText>
                                            )}
                                        </InputGroup>
                                        {isStaffRequired &&
                                            <InputGroup>
                                                <Label htmlFor="assignTo">Assign To Staff *</Label>
                                                <FieldWrappers onClick={() => setIsAssignStaffModalOpen(true)}>
                                                    <Field
                                                        type="text"
                                                        name="assignToId"
                                                        id="assignToId"
                                                        autoComplete="off"
                                                        readOnly
                                                        value={getAssignStaffLabel()}
                                                        className="w-full border-none outline-none bg-transparent cursor-pointer"
                                                    />
                                                    <IconWrapper >
                                                        <FaPlus className="w-3 h-3" />
                                                    </IconWrapper>
                                                    {/* <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" /> */}

                                                </FieldWrappers>
                                                {errors.assignToId && touched.assignToId && (
                                                    <ErrorText>{errors.assignToId}</ErrorText>
                                                )}
                                            </InputGroup>}
                                    </Wrapper>
                                </ScrollableContent>
                                <ActionSection>
                                    <SideCancelBtn
                                        type="button"
                                        onClick={() => setIsAssignmentDetails(false)}
                                    >
                                        Cancel
                                    </SideCancelBtn>
                                    <SubmitBtn type="submit" disabled={assignPropertyLoading}>
                                        {assignPropertyLoading ? "Submitting..." : "Submit"}
                                    </SubmitBtn>
                                </ActionSection>
                                <SinglePropSelectModal
                                    isOpen={showPropertyModal}
                                    onClose={() => setShowPropertyModal(false)}
                                    onSelect={handleSelectedProperty}
                                    options={property}
                                    selectedProperty={selectedProperty}
                                />
                                <SelectOptionModal
                                    isOpen={isAssignModalOpen}
                                    onClose={() => setIsAssignModalOpen(false)}
                                    title="Select Assign To"
                                    options={assignToOptions}
                                    selectedValue={values.assignTo}
                                    onSelect={handleAssignToSelect}
                                    searchPlaceholder="Search assign to..."
                                />
                                <SelectOptionModal
                                    isOpen={isAssignStaffModalOpen}
                                    onClose={() => setIsAssignStaffModalOpen(false)}
                                    title="Select Assign To Staff"
                                    options={assignToStaffOptions}
                                    selectedValue={values.assignToId}
                                    onSelect={handleAssignToStaffSelect}
                                    searchPlaceholder="Search assign to..."
                                />
                            </Form>
                        )
                    }}
                </Formik>
            </Content>
        </Container>
    );
};

const ErrorText = tw.div`text-red-500 text-sm ml-0.5`;
const InputGroup = tw.div`w-full flex flex-col mt-2 md:mt-0`;
const Label = tw.label`text-sm text-gray-600 font-normal mb-1.5`;
const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const Title = tw.h1`text-white text-lg md:text-xl font-medium`;
const CloseButton = tw.button`text-white`;
const Content = tw.div`px-6 h-full flex flex-col justify-between relative`;
const IconWrapper = tw.div`mr-2 flex-shrink-0 p-2 rounded-lg transition-all duration-300 bg-gray-100 text-gray-600`;
export default AssignmentDetails;
